import './filters-style.scss'

import classNames from 'classnames'
import _ from 'lodash'
import React, { useCallback, useEffect, useState } from 'react'

import { useCategories } from '../../hooks/useCategories'
import { withTrans } from '../../i18n/withTrans'
import Button from '../button-filter/button-filter'
import { orderFilterItems } from './filter-order'
import { useHashUrlFilter } from './use-hash-url-filter'

const Filters = ({
  title,
  titleTwo,
  onClick,
  type = 'event',
  typeTwo = undefined,
  selectedCategories = {},
  noTrending,
  t,
}) => {
  const [subCategories, setSubCategories] = useState([])
  const [subCategoriesTwo, setSubCategoriesTwo] = useState([])
  const { withSubCategories } = useCategories()

  const onFilter1Click = useCallback(
    (name) => {
      const newState = { ...selectedCategories }
      newState[type] = name === selectedCategories[type] ? null : name
      onClick(newState)
    },
    [onClick, selectedCategories, type]
  )

  const onFilter2Click = useCallback(
    (name) => {
      const newState = { ...selectedCategories }
      newState[typeTwo] = name === selectedCategories[typeTwo] ? null : name
      onClick(newState)
    },
    [onClick, selectedCategories, typeTwo]
  )

  useEffect(() => {
    const category = _.filter(withSubCategories, (c) => c.description === type)
    setSubCategories(_.get(_.head(category), 'wpChildren', []))
    if (typeTwo) {
      const category2 = _.filter(
        withSubCategories,
        (c) => c.description === typeTwo
      )
      setSubCategoriesTwo(
        orderFilterItems(typeTwo, _.get(_.head(category2), 'wpChildren', []))
      )
    }
  }, [type, typeTwo, withSubCategories])

  useHashUrlFilter(
    selectedCategories,
    subCategories,
    subCategoriesTwo,
    type,
    typeTwo,
    onClick
  )

  return (
    <div
      className={classNames({
        'container-filters': true,
        'no-trending': noTrending,
      })}
    >
      <div className="container-type-filters">
        <p className="text-type-filters">{t(`ui.filters.${title}`)}: </p>
        <div className="box-type-filters">
          {_.map(subCategories, (button) => (
            <Button
              key={button.slug}
              name={button.name}
              slug={button.slug}
              onPress={() => onFilter1Click(button.description)}
              active={selectedCategories[type] === button.description}
              hash={button.description}
            />
          ))}
        </div>
      </div>
      {typeTwo && (
        <div className="container-type-filters">
          <>
            <p className="text-type-filters">{t(`ui.filters.${titleTwo}`)}: </p>
            <div className="box-type-filters">
              {_.map(subCategoriesTwo, (button) => (
                <Button
                  type={typeTwo}
                  key={button.slug}
                  name={button.name}
                  slug={button.slug}
                  hash={button.description}
                  onPress={() => onFilter2Click(button.description)}
                  active={selectedCategories[typeTwo] === button.description}
                />
              ))}
            </div>
          </>
        </div>
      )}
    </div>
  )
}

export default withTrans(Filters)
